import themeConfig from '@configs/themeConfig'

const Logo = (props) => {
  return (
    <img alt='App Logo' {...props} src={themeConfig.app.appLogoImage} />
  )
}

export default Logo